export default __webpack_public_path__ + "static/media/support-helping.6446fe4a.svg";